import ReactDOM from "react-dom";
import cn from "classnames";
import React from "react";
import { useTranslation } from "../../hooks/useTranslation";
import { twMerge } from "tailwind-merge";

type Props = {
  children: any;
  onCancel: () => void;
};

export const ImageViewModal: React.FC<Props> = ({

                                                  children,
                                                  onCancel
                                                }) => {
  const { t } = useTranslation();
  const modalPortal = document.getElementById("modal-portal");
  return (
    <>
      {ReactDOM.createPortal(
        <div
          className="relative z-3 cursor-pointer"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
          <div className="fixed inset-0 overflow-y-auto" onClick={onCancel}>
            <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
              <div
                className={twMerge(cn("relative rounded-lg text-left overflow-hidden"))}>
                {children}
              </div>
            </div>
          </div>
        </div>,
        modalPortal as Element
      )}
    </>
  );
};
